import { Component } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DynamicFormDto } from '../../../../service/dto';
import { FormResult } from '../../../../components/dynamic-form/dynamic-form.component';
import { HttpAgentAdminService } from '../../../../service/http-agent.service';

@Component({
	selector: 'app-agent-admin-form',
	standalone: false,
	templateUrl: './agent-admin-form.component.html',
	styleUrl: './agent-admin-form.component.scss'
})
export class AgentAdminFormComponent {
	data?: DynamicFormDto;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private httpService: HttpAgentAdminService) { }

	ngOnInit(): void {
		const id = this.activatedRoute.paramMap.subscribe(paramMap => {
			const id = paramMap.get('id');
			if (id) {
				this.httpService.get(+id).subscribe(result => {
					this.data = result;
				});
			} else {
				this.httpService.getForm().subscribe(result => {
					this.data = result;
				});
			}
		});
	}
	doHandleResult(input: FormResult){
		if(input.type == 'Cancel'){
			this.router.navigate(['/agent/admin','list']);
			return;
		}
		(this.data?.id ? (this.httpService.edit(this.data.id, input.data)) : (this.httpService.create(input.data))).subscribe(result => {
			this.router.navigate(['/agent/admin','list']);
		});
	}
}
